import { useMemo } from "react";
import { tableUtils } from "../utils";
import { useDeepCompareMemoize } from "use-deep-compare-effect";

const useTableData = ({ loading, data, loadingPlaceholdersRows = 10, mapCallback = null }) => {
  const memoData = useDeepCompareMemoize(data);

  return useMemo(() => {
    if (loading) {
      return tableUtils.getTablePlaceholders(loadingPlaceholdersRows);
    }

    return mapCallback ? memoData.map(mapCallback) : memoData;
  }, [loading, memoData]);
};

export default useTableData;
